import * as React from 'react';
import { cn } from '../lib/cn';

type Tone = 'info' | 'ok' | 'warn' | 'bad';
// Prototype banners: tinted background, the title in a dark shade of the tone, the text in ink.
const tones: Record<Tone, { box: string; title: string }> = {
  info: { box: 'bg-info-bg border-info/20', title: 'text-info-ink' }, ok: { box: 'bg-ok-bg border-ok/20', title: 'text-ok-ink' },
  warn: { box: 'bg-warn-bg border-warn/25', title: 'text-warn-ink' }, bad: { box: 'bg-bad-bg border-bad/20', title: 'text-bad-ink' },
};

export function Alert({ tone = 'info', title, children, className }: { tone?: Tone; title?: string; children?: React.ReactNode; className?: string }) {
  return (
    <div role={tone === 'bad' ? 'alert' : 'status'} className={cn('rounded-card border px-5 py-3.5 text-sm text-ink-2', tones[tone].box, className)}>
      {title && <p className={cn('font-semibold', tones[tone].title)}>{title}</p>}
      {children && <div className={cn(title ? 'mt-0.5' : '', !title && tones[tone].title)}>{children}</div>}
    </div>
  );
}
